import { TOGGLE_SIDEBAR } from "../Constants/action-types"

export function ToggleSidebar(param){
  return function(dispatch){
    return dispatch({ type: TOGGLE_SIDEBAR, payload: param });
  }
}